import Button from '@components/ui/ButtonV2/Button'
import clsx from 'clsx'
import parse, { DOMNode, domToReact, Element } from 'html-react-parser'
import React, { CSSProperties, FC, useRef } from 'react'
import Link from '../Link/Link'
import s from './TrustedHtml.module.scss'

type TrustedHtmlProps = {
  html?: string
  maxWidth?: number
}

const TrustedHtml: FC<
  TrustedHtmlProps &
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >
> = ({ html, maxWidth, ...props }) => {
  const ref = useRef<HTMLDivElement>(null)

  return html ? (
    <div
      {...props}
      className={clsx(s.root, props.className, 'richText')}
      style={
        {
          ...props.style,
          '--max-width': maxWidth === 0 ? '100vw' : `${maxWidth}vw`,
        } as CSSProperties
      }
      ref={ref}
    >
      {parse(html, {
        replace: (domNode) => {
          if (domNode instanceof Element && domNode.type === 'script') {
            if (ref.current) {
              const script = document.createElement('script')
              script.async = true
              if (domNode?.attribs?.src) script.src = domNode?.attribs?.src
              if (domNode?.attribs?.id) {
                script.id = domNode?.attribs?.id
                if (document.getElementById(domNode?.attribs?.id)) return
              }
              script.innerHTML = domToReact(domNode.children as any).toString()
              ref.current.appendChild(script)

              //@ts-ignore
              if (domNode.children[0]?.data && typeof window !== 'undefined') {
                //@ts-ignore
                window.eval(domNode.children[0].data)
              }
            }

            return <></>
          }

          // replaceButton(domNode)

          if (
            isElement(domNode) &&
            domNode.attribs &&
            domNode.attribs.href &&
            domNode.name == 'a'
          ) {
            return (
              <Link
                link={{
                  url: domNode.attribs.href,
                  target:
                    domNode.attribs.target === '_blank' ? '_blank' : undefined,
                  type:
                    domNode.attribs.target &&
                    domNode.attribs.target === '_blank'
                      ? 'EXTERNAL'
                      : undefined,
                }}
              >
                {domToReact(domNode.children as any, { replace })}
              </Link>
            )
          }
          return replace(domNode)
        },
      })}
    </div>
  ) : null
}

const replace = (domNode: DOMNode) => {
  //@ts-ignore
  if (isElement(domNode)) {
    //@†s-ignore
    const classes = domNode.attribs?.class as string | null

    if (
      classes?.includes('buttonPrimaryBlack') ||
      classes?.includes('buttonBlackHover')
    ) {
      if (
        domNode.children?.length > 0 &&
        isAElement(domNode.children[0] as DOMNode)
      ) {
        const domNodeChild = domNode.children[0] as any
        return (
          <Button
            as={Link}
            link={{
              url: domNodeChild.attribs.href,
              target:
                domNodeChild.attribs.target === '_blank' ? '_blank' : undefined,
              type:
                domNodeChild.attribs.target &&
                domNodeChild.attribs.target === '_blank'
                  ? 'EXTERNAL'
                  : undefined,
            }}
            size="medium"
          >
            {domToReact(domNodeChild.children, { replace })}
          </Button>
        )
      } else
        return (
          <Button size="medium">
            {domToReact(domNode.children as any, { replace })}
          </Button>
        )
    }
    domNode?.children?.forEach((child) => {
      replace(child as any)
    })
  }
}
const isAElement = (domNode: DOMNode): domNode is Element => {
  return (
    isElement(domNode) &&
    domNode.attribs &&
    domNode.attribs.href &&
    domNode.name == 'a'
  )
}
const isElement = (domNode: DOMNode): domNode is Element => {
  const isTag = domNode.type === 'tag'
  const hasAttributes = (domNode as Element).attribs !== undefined

  return isTag && hasAttributes
}

export default React.memo(TrustedHtml)
